export default function BackgroundPages() {
  return (
    <div className="apply-trial-hero-bg" aria-hidden="true">
      <img src="/static/images/KeyVisuals/hero.png" alt="" className="hero-static-image" />
      <div className="hero-video-overlay-profile" aria-hidden="true" />
    </div>
  );
}
